export default __webpack_public_path__ + "static/media/SIMPLE-Mango-Chili-Lime-Margaritas.8e721ba4.jpeg";